import { render } from "./HeaderDefault.vue?vue&type=template&id=55e3ba07"
import script from "./HeaderDefault.vue?vue&type=script&lang=js"
export * from "./HeaderDefault.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__